<template>
  <div>
    <div v-if="$auth.policies['view-club']">
      <div class="pa-4 d-flex justify-space-between align-center">
        <div>
          <Breadcrumbs
            :headline="club.name"
            :link="[
              { text: 'Học sinh', href: '#' },
              { text: 'Chi tiết câu lạc bộ', href: '#' }
            ]"
          />
        </div>
        <div>
          <v-btn
            v-if="$auth.policies['update-club']"
            color="primary"
            class="mx-1 mt-2"
            @click="club.published ? hideFromStudent() : showForStudent()"
          >
            {{ club.published ? 'Ẩn khỏi PH' : 'Hiển thị cho PH' }}
          </v-btn>
          <v-btn
            v-if="$auth.policies['update-club']"
            color="primary"
            class="mx-1 mt-2"
            @click="club.isOpenRegister ? closeRegister() : publish()"
          >
            {{ club.isOpenRegister ? 'Đóng đăng kí' : 'Mở đăng kí' }}
          </v-btn>
        </div>
      </div>
      <BasicInfoView />
      <v-col class="ml-1">
        <ClubTab />
      </v-col>
      <div v-if="$auth.policies['delete-club']" class="d-flex justify-center mt-3 mb-6">
        <v-btn color="error" outlined class="mx-1 mt-2" @click="remove">
          Xoá câu lạc bộ
        </v-btn>
      </div>
    </div>
    <div v-else>
      <Page403></Page403>
    </div>
  </div>
</template>
<script>
import Page403 from '@/views/Page403.vue'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import BasicInfoView from '../../modules/club/detail-club/BasicInfoView.vue'
import ClubTab from '../../modules/club/detail-club/ClubTab.vue'
import { mapActions, mapState } from 'vuex'
export default {
  components: {
    Page403,
    Breadcrumbs,
    BasicInfoView,
    ClubTab
  },
  computed: {
    ...mapState({
      club: state => state.club.item
    })
  },
  mounted() {
    this.fetchOne(this.$route.params.id)
  },
  methods: {
    ...mapActions({
      fetchOne: 'club/fetchOne',
      update: 'club/update',
      delete: 'club/delete'
    }),

    hideFromStudent() {
      this.$dialog.confirm({
        title: 'Xác nhận ẩn',
        text: 'Sau khi ẩn, PH sẽ không thấy CLB hiển thị trên danh sách của mình nữa.',
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        done: async () => {
          try {
            this.$loading.active = true
            await this.update({ id: this.$route.params.id, published: 'false' })
            this.$alert.success('Ẩn khỏi PH thành công!')
            this.fetchOne(this.$route.params.id)
          } catch (error) {
            this.$alert.error(error)
          } finally {
            this.$loading.active = false
          }
        }
      })
    },
    showForStudent() {
      this.$dialog.confirm({
        title: 'Xác nhận hiển thị',
        text: 'Sau khi hiển thị, PH sẽ thấy CLB hiển thị trên danh sách của mình.',
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        done: async () => {
          try {
            this.$loading.active = true
            await this.update({ id: this.$route.params.id, published: true })
            this.$alert.success('Hiển thị cho PH thành công!')
            this.fetchOne(this.$route.params.id)
          } catch (error) {
            this.$alert.error(error)
          } finally {
            this.$loading.active = false
          }
        }
      })
    },

    publish() {
      this.$dialog.confirm({
        title: 'Xác nhận mở đăng kí',
        text: 'Sau khi mở đăng kí thì phụ huynh sẽ có thể bắt đầu đăng kí vào câu lạc bộ.',
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        done: async () => {
          try {
            this.$loading.active = true
            await this.update({ id: this.$route.params.id, published: true, isOpenRegister: true })
            this.$alert.success('Mở đăng kí thành công!')
            this.fetchOne(this.$route.params.id)
          } catch (error) {
            this.$alert.error(error)
          } finally {
            this.$loading.active = false
          }
        }
      })
    },
    closeRegister() {
      this.$dialog.confirm({
        title: 'Xác nhận đóng đăng kí',
        text: 'Sau khi đóng đăng kí phụ huynh sẽ không thể đăng kí vào câu lạc bộ nữa.',
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        done: async () => {
          try {
            this.$loading.active = true
            await this.update({ id: this.$route.params.id, isOpenRegister: 'false' })
            this.$alert.success('Đóng đăng kí thành công!')
            this.fetchOne(this.$route.params.id)
          } catch (error) {
            this.$alert.error(error)
          } finally {
            this.$loading.active = false
          }
        }
      })
    },
    remove() {
      this.$dialog.confirm({
        title: 'Xác nhận xoá câu lạc bộ',
        text: 'Việc xoá câu lạc bộ sẽ xoá tất cả các dữ liệu liên quan đên câu lạc bộ này.',
        okText: 'Xoá',
        cancelText: 'Hủy',
        type: 'delete',
        done: async () => {
          try {
            this.$loading.active = true
            await this.delete(this.$route.params.id)
            this.$alert.success('Xoá câu lạc bộ thành công')
            this.$router.push('/club')
          } catch (error) {
            this.$alert.error(error)
          } finally {
            this.$loading.active = false
          }
        }
      })
    }
  }
}
</script>
<style scoped>
td {
  white-space: nowrap !important;
}
</style>
